// Animated cyberpunk background: deep navy gradient + perspective neon grid + twinkling stars.
export const CyberBackground = () => (
  <div className="cyber-bg z-0" data-testid="cyber-background" aria-hidden>
    <div className="stars" />
    <div className="cyber-grid" />
    <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-[#0A0E27]" />
  </div>
);

export default CyberBackground;
